// extracted by mini-css-extract-plugin
module.exports = {"container":"Image_container__3I7AC"};